import { Component, HostBinding, ContentChild } from "@angular/core";
import { SuiSidebar } from "./sidebar";
import { SuiSidebarSibling } from "./sidebar-sibling";
import * as ɵngcc0 from '@angular/core';

var _c0 = ["*"];
var SuiSidebarContainer = /** @class */ (function () {
    function SuiSidebarContainer() {
        this._containerClasses = true;
    }
    SuiSidebarContainer.prototype.ngAfterContentInit = function () {
        if (!this.sidebar) {
            throw new Error("You must include a <sui-sidebar> element within the container.");
        }
        this.service = this.sidebar.service;
        if (!this.sibling) {
            throw new Error("You must include a <sui-sidebar-sibling> element within the container.");
        }
        this.sibling.service = this.service;
    };
    /** @nocollapse */
    SuiSidebarContainer.ctorParameters = function () { return []; };
    SuiSidebarContainer.propDecorators = {
        "_containerClasses": [{ type: HostBinding, args: ["class.pushable",] },],
        "sidebar": [{ type: ContentChild, args: [SuiSidebar,] },],
        "sibling": [{ type: ContentChild, args: [SuiSidebarSibling,] },],
    };
SuiSidebarContainer.ɵfac = function SuiSidebarContainer_Factory(t) { return new (t || SuiSidebarContainer)(); };
SuiSidebarContainer.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SuiSidebarContainer, selectors: [["sui-sidebar-container"]], contentQueries: function SuiSidebarContainer_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, SuiSidebar, 5);
        ɵngcc0.ɵɵcontentQuery(dirIndex, SuiSidebarSibling, 5);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.sidebar = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.sibling = _t.first);
    } }, hostVars: 2, hostBindings: function SuiSidebarContainer_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("pushable", ctx._containerClasses);
    } }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SuiSidebarContainer_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, styles: ["[_nghost-%COMP%] {\n    display: block;\n}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SuiSidebarContainer, [{
        type: Component,
        args: [{
                selector: "sui-sidebar-container",
                template: "<ng-content></ng-content>",
                styles: ["\n:host {\n    display: block;\n}\n"]
            }]
    }], function () { return []; }, { _containerClasses: [{
            type: HostBinding,
            args: ["class.pushable"]
        }], sidebar: [{
            type: ContentChild,
            args: [SuiSidebar]
        }], sibling: [{
            type: ContentChild,
            args: [SuiSidebarSibling]
        }] }); })();
    return SuiSidebarContainer;
}());
export { SuiSidebarContainer };

